<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<lms-notes-data-list [loadData]='loadData' [selectedTab]='selectedTab' [subTypes]='subTypes' [winCode]="'LWNN'" [notesType]="'S'"
    [noteTextParent]='noteTextParent' [blankMessage]='blankMessage' [errorMessage]='errorMessage'></lms-notes-data-list>